import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MyTranslatePipe} from '../../pipes/my-translate.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    MyTranslatePipe
  ],
  exports: [
    MyTranslatePipe
  ]
})
export class MyTranslateModule { }



// WEBPACK FOOTER //
// ./src/app/modules/my-translate-module/my-translate-module.ts